/**
 * Filename: home.js
 * Home page
 * Component path
 * IconBoxed  'componenet/iconboxes.js'
 * Charts compoenent from 'compoenent/charts'
 * Table from 'containers/table.js'
 */

import React, {Component} from 'react';
import SidebarMenuRouters from "../../routers/routers.js";
import Header from '../../containers/header.js';
import Places from '../../containers/places.js';
import {Redirect} from 'react-router';

class Client extends Component {


  constructor(props) {
    super(props);
    var userData = JSON.parse(localStorage.getItem("userData"));
    this.state = {rol: userData.rol}
  }

  render() {
    var result;

    if (this.state.rol === "client") {
      result = <div>
        <SidebarMenuRouters profile="/profile-client/place/" place=""/>
        <Header userName="Cliente"/>
        <Places profile="/profile-client/place/"/>
      </div>
    } else {
      result = <Redirect to={"/"}/>
    }
    return (
      <div>
        {result}
      </div>
    );
  }
}

export default Client;



// WEBPACK FOOTER //
// ./src/scene/profile/client.js